import type { ValidValue } from "../models/common/ValidValue";
export function getValidValueDisplayText(
  value: Partial<ValidValue> | null | undefined,
  dropdownDisplayMode?: any
): string {
  const code = String(value?.Code ?? "").trim();
  const description = String(value?.Description ?? "").trim();
  const mode = String(dropdownDisplayMode ?? "").trim().toLowerCase();

  if (mode === "code") return code || description;
  if (mode === "description") return description || code;
  if (mode === "both") {
    if (code && description) return `${code} - ${description}`;
    return code || description;
  }

  return description || code;
}

